/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import DbBaseObject from "@shared/DbBaseObject";
import {ClearanceLevelEnum} from "@shared/Profile/ClearanceLevelEnum";

export default class SessionPlanSharedContent extends DbBaseObject {
	contentByItemId: Object = {}
	tagsByItemId: Object = {}
	sharedWithIds: string[] = []
	createdById: string = null
	clearanceLevel: number = ClearanceLevelEnum.STANDARD

	constructor(options = {}) {
		super(options)
		this.applyOptions(options)
	}

	getContent(itemId) {
		return this.contentByItemId?.[itemId] || ""
	}

	setContent(itemId, content) {
		this.contentByItemId = {...this.contentByItemId, [itemId]: content || ""}
		this.updatedAt = Date.now()
	}

	getTags(itemId) {
		return this.tagsByItemId?.[itemId] || []
	}

	setTags(itemId, tags = []) {
		this.tagsByItemId = {...this.tagsByItemId, [itemId]: tags}
		this.updatedAt = Date.now()
	}
}
